module.exports = __webpack_public_path__ + "img/2007.0d02da9e.jpg";